export default "__VITE_ASSET__ZYnjWeHI__"